import React from 'react';

import { Center } from './Center';
import { Spinner } from './Spinner';

export function FullScreenLoading() {
  return (
    <Center isFullScreen>
      <Spinner type="fullScreenLoading" size="xl" />
    </Center>
  );
}
